import { Link } from "wouter";
import { useTranslation } from "react-i18next";
import { staffDate } from "@/lib/staff-identity";
import { advanceMoney, type StaffAdvance } from "./use-staff-advances";
import { planMonthLabel } from "./StaffAdvancePlan";

export default function StaffAdvanceShortTakes({advance}:{advance:StaffAdvance}){
  const {i18n}=useTranslation(),rtl=i18n.language==="ar";
  if(!advance.shortTakes?.length)return null;
  return <div className="adtl">{advance.shortTakes.map((entry,index)=>{
    const reason=entry.reason==="other"?(rtl?"أخرى":"Other"):entry.reason;
    return <div className="adev open" key={`${entry.payRecordId}-${entry.month}-${index}`}><i/><div>
      <b>{rtl?`خُصم ${advanceMoney(entry.actualAmount)} بدلًا من ${advanceMoney(entry.expectedAmount)} جنيه`:`${advanceMoney(entry.actualAmount)} taken instead of ${advanceMoney(entry.expectedAmount)} EGP`}</b>
      <small>{planMonthLabel(entry.month,rtl)} · <Link className="lnk" href={`/staff/pay-records?pay=${encodeURIComponent(entry.payRecordId)}`}>{entry.payNumber|| (rtl?"فتح سجل الصرف":"Open pay record")}</Link> · {staffDate(entry.createdAt,rtl)} · {rtl?"بواسطة":"by"} {entry.actorName||"—"}</small>
      <small>{rtl?"السبب":"Reason"}: {reason}{entry.details?`: ${entry.details}`:""}</small>
    </div></div>;
  })}</div>;
}
